export const QUERY_KEYS = {
  nonMemberPtInfo: 'nonMemberPtInfo',
};
